import { render, staticRenderFns } from "./ListTableBlank.vue?vue&type=template&id=69760ff8&scoped=true&"
import script from "./ListTableBlank.vue?vue&type=script&lang=js&"
export * from "./ListTableBlank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69760ff8",
  null
  
)

export default component.exports